const routes = [
  {
    path: '/student/searchevaluation',
    name: 'student-evaluation-history',
    component: () =>
      import('@/views/student/evaluation-history/StudentEvaluationHistory.vue'),
  },
  {
    path: '/student/addevaluation',
    name: 'student-evaluation-history-add',
    component: () =>
      import(
        '@/views/student/evaluation-history/StudentEvaluationHistoryAdd.vue'
      ),
  },
  {
    path: '/student/editevaluation',
    name: 'student-evaluation-history-edit',
    component: () =>
      import(
        '@/views/student/evaluation-history/StudentEvaluationHistoryEdit.vue'
      ),
  },
];

export default routes;
